export default {
  ticket_query: '/queues/query'
}
